import { render, staticRenderFns } from "./SendEgiftPanelReview.vue?vue&type=template&id=c7729df0&scoped=true"
import script from "./SendEgiftPanelReview.vue?vue&type=script&lang=ts"
export * from "./SendEgiftPanelReview.vue?vue&type=script&lang=ts"
import style0 from "./SendEgiftPanelReview.vue?vue&type=style&index=0&id=c7729df0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7729df0",
  null
  
)

export default component.exports